// "The One-Line Bug That Faked OOM" — mutual-recursion stack overflow short.
// Cold Compute / Neon kit. ~127s @ 30fps.
//
// GROUNDED in EAKC-MVP:
//   docs/content/07-building-on-1gb-ram.md  §17:30 (Railway red herring), §19:30 (mutual recursion)
//   src/lib/rag/adaptive-chunker.ts  (chunkMarkdownStructured ⇄ chunkGeneralStructured; fix @1108-1111)
//   .claude/CLAUDE.md deployment topology (sync runs in-process on Dokploy VPS, NOT Railway)
export { FPS, WIDTH, HEIGHT } from "../../coldcompute/theme";

// Scene frame-timing map. start/duration in frames @30fps; contiguous.
export const SCENE = {
  hook: { start: 0, duration: 150 }, //         0:00–0:05   2 weeks → 1 line
  symptom: { start: 150, duration: 540 }, //    0:05–0:23   dies at ~20%, silent
  diagnosis: { start: 690, duration: 540 }, //  0:23–0:41   "must be OOM" → upgrade Railway
  twist: { start: 1230, duration: 510 }, //     0:41–0:58   the sync never ran on Railway
  realbug: { start: 1740, duration: 600 }, //   0:58–1:18   the mutual-recursion cycle
  code: { start: 2340, duration: 690 }, //      1:18–1:41   the one-line fix
  payoff: { start: 3030, duration: 510 }, //    1:41–1:58   2,110 chunks · flat memory
  outro: { start: 3540, duration: 300 }, //     1:58–2:08
} as const;

export const TOTAL_DURATION = 3840; // 128s

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
